import { supabase } from '@/lib/supabase'

export const THERMO_TIP_KEY = 'thermometer.member_tip'

export const DEFAULT_THERMOMETER_MEMBER_TIP = `O termometro mede em tempo real o ponto ideal do ativo. Quando o marcador esta no verde (50%), o ativo possivelmente esta no melhor ponto da oportunidade.

Se o valor se afastar negativamente de 50% (ficar menor a cada atualizacao), a oportunidade esta diminuindo a probabilidade de exito.

O contrario tambem e avaliado: quanto maior a distancia positiva (maior a % a cada atualizacao), maior a probabilidade de exito.`

export async function getThermometerMemberTip(): Promise<string> {
  const { data, error } = await supabase
    .from('app_settings')
    .select('value')
    .eq('key', THERMO_TIP_KEY)
    .maybeSingle()
  if (error) return DEFAULT_THERMOMETER_MEMBER_TIP
  const v = (data?.value as string) || ''
  return v.trim() ? v : DEFAULT_THERMOMETER_MEMBER_TIP
}

export async function setThermometerMemberTip(text: string): Promise<void> {
  const val = (text || '').trim() || DEFAULT_THERMOMETER_MEMBER_TIP
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: THERMO_TIP_KEY, value: val }, { onConflict: 'key' })
  if (error) throw error
}

